import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { Section, Reveal } from './Section';
const rows = [{
  situation: 'No sabés cómo cuidar tu plata al empezar',
  without: 'Tomás decisiones a ciegas',
  with: 'Una calculadora simple para orientarte'
}, {
  situation: 'Ves un consejo en internet',
  without: 'No sabés si tiene sentido para vos',
  with: 'Aprendés a observar y practicar antes de poner dinero'
}, {
  situation: 'Querés prepararte para un gasto inesperado',
  without: 'Seguís sin un plan ni respaldo',
  with: 'Empezás a ordenar tus decisiones paso a paso'
}, {
  situation: 'Querés aprender pero no podés pagar $500 USD',
  without: 'Sentís que quedás afuera',
  with: 'Un camino claro, sin esa barrera'
}];
export function ComparisonTable() {
  return <Section className="bg-ink-950" data-id="element-32" data-mp="1wy4ht26qq39p">
      <Reveal data-id="element-33" data-mp="1x18pi9jezh54">
        <h2 className="font-display text-2xl font-bold leading-tight tracking-tight text-white sm:text-3xl lg:text-4xl" data-id="element-34" data-mp="21xpfl9a6c5ku">
          Con y sin Capital Consciente
        </h2>
      </Reveal>

      <Reveal delay={0.08} data-id="element-35" data-mp="29vttf6808tn7">
        <div className="mt-8 overflow-hidden rounded-2xl border border-white/10" data-id="element-36" data-mp="29wlpei5ikte0">
          <div className="grid grid-cols-3 border-b border-white/10 bg-ink-850 text-xs font-semibold uppercase tracking-wide text-gray-400 sm:text-sm" data-id="element-37" data-mp="2nvbou4ft355j">
            <div className="p-3 sm:p-4" data-id="element-38" data-mp="2iuxgelaalt6z">Tu situación</div>
            <div className="border-l border-white/10 p-3 sm:p-4" data-id="element-39" data-mp="2wvrr5aktc68t">Sin CC</div>
            <div className="border-l border-white/10 bg-brand-soft p-3 text-brand sm:p-4" data-id="element-40" data-mp="2suo7se3k3s2u">Con CC</div>
          </div>

          {rows.map((row, index) => <div key={row.situation} className={`grid grid-cols-3 text-sm ${index % 2 === 0 ? 'bg-ink-900' : 'bg-ink-950'}`} data-id="element-41" data-mp="36ll0e4xhg99w" data-mpi={index}>
              <div className="p-3 font-medium text-gray-200 sm:p-4" data-id="element-42" data-mp="31pcdg5d1nbs6">{row.situation}</div>
              <div className="flex items-start gap-2 border-l border-white/10 p-3 text-gray-400 sm:p-4" data-id="element-43" data-mp="3gi65eq9i5kdq">
                <XIcon className="mt-0.5 h-4 w-4 flex-none text-red-400/70" data-id="element-44" data-mp="3bjcpysannjax" />
                <span data-id="element-45" data-mp="3ipyngjvhn8kp">{row.without}</span>
              </div>
              <div className="flex items-start gap-2 border-l border-white/10 bg-brand-soft/40 p-3 text-gray-100 sm:p-4" data-id="element-46" data-mp="3nmp5hcquse8r">
                <CheckIcon className="mt-0.5 h-4 w-4 flex-none text-brand" data-id="element-47" data-mp="3sls0e4d4d430" />
                <span data-id="element-48" data-mp="185qpexyux1r">{row.with}</span>
              </div>
            </div>)}
        </div>
      </Reveal>
    </Section>;
}